module.exports = __webpack_public_path__ + "img/3.41530403.jpg";